export default __webpack_public_path__ + "static/media/icon_circle_red_marker.ab2ff83d.svg";